import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/inventario`

    return {
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list() {

            return repository.get(`${baseUrl}/list`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        getIntegracaoBnafarMedicamentos(queryParms) {

            return repository.get(`${baseUrl}/integracao-bnafar-medicamentos?${urlUtil.serialize(queryParms)}`)
        },
    }
}